import {NavLink as Base, NavLinkProps} from "react-router-dom";
import styled from "styled-components";

export const NavLink = styled<NavLinkProps>(Base)``;
